// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-radio-button ~ .mat-radio-button {
  margin-left: 16px;
}

.civil-id-photos > div,
.rc-book-photos > div {
  margin-bottom: 20px;
}

.mat-form-field {
  width: 100%;
}

form small.error {
  position: relative;
  top: -24px;
}

.param-name {
  min-width: 40%;
}

.light-data-text {
  font-size: 16px;
}

th {
  padding: 6px 4px;
  border-top: none;
}

td {
  padding: 6px 4px;
  border-top: none;
}

tr {
  border-bottom: 1px solid #e0e0e0;
}
.mat-form-field .mat-form-field-wrapper {
  padding: 0px !important;
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInF1b3RlLWhpc3RvcnktZGV0YWlscy5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsaUJBQWlCO0FBQ25COztBQUVBOztFQUVFLG1CQUFtQjtBQUNyQjs7QUFFQTtFQUNFLFdBQVc7QUFDYjs7QUFFQTtFQUNFLGtCQUFrQjtFQUNsQixVQUFVO0FBQ1o7O0FBRUE7RUFDRSxjQUFjO0FBQ2hCOztBQUVBO0VBQ0UsZUFBZTtBQUNqQjs7QUFFQTtFQUNFLGdCQUFnQjtFQUNoQixnQkFBZ0I7QUFDbEI7O0FBRUE7RUFDRSxnQkFBZ0I7RUFDaEIsZ0JBQWdCO0FBQ2xCOztBQUVBO0VBQ0UsZ0NBQWdDO0FBQ2xDO0FBQ0E7RUFDRSx1QkFBdUI7QUFDekIiLCJmaWxlIjoicXVvdGUtaGlzdG9yeS1kZXRhaWxzLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIubWF0LXJhZGlvLWJ1dHRvbiB+IC5tYXQtcmFkaW8tYnV0dG9uIHtcbiAgbWFyZ2luLWxlZnQ6IDE2cHg7XG59XG5cbi5jaXZpbC1pZC1waG90b3MgPiBkaXYsXG4ucmMtYm9vay1waG90b3MgPiBkaXYge1xuICBtYXJnaW4tYm90dG9tOiAyMHB4O1xufVxuXG4ubWF0LWZvcm0tZmllbGQge1xuICB3aWR0aDogMTAwJTtcbn1cblxuZm9ybSBzbWFsbC5lcnJvciB7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgdG9wOiAtMjRweDtcbn1cblxuLnBhcmFtLW5hbWUge1xuICBtaW4td2lkdGg6IDQwJTtcbn1cblxuLmxpZ2h0LWRhdGEtdGV4dCB7XG4gIGZvbnQtc2l6ZTogMTZweDtcbn1cblxudGgge1xuICBwYWRkaW5nOiA2cHggNHB4O1xuICBib3JkZXItdG9wOiBub25lO1xufVxuXG50ZCB7XG4gIHBhZGRpbmc6IDZweCA0cHg7XG4gIGJvcmRlci10b3A6IG5vbmU7XG59XG5cbnRyIHtcbiAgYm9yZGVyLWJvdHRvbTogMXB4IHNvbGlkICNlMGUwZTA7XG59XG4ubWF0LWZvcm0tZmllbGQgLm1hdC1mb3JtLWZpZWxkLXdyYXBwZXIge1xuICBwYWRkaW5nOiAwcHggIWltcG9ydGFudDtcbn1cbiJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/secure/quote-history-details/quote-history-details.component.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;AACA;EACE,uBAAuB;AACzB;;AAEA,o1CAAo1C","sourcesContent":[".mat-radio-button ~ .mat-radio-button {\n  margin-left: 16px;\n}\n\n.civil-id-photos > div,\n.rc-book-photos > div {\n  margin-bottom: 20px;\n}\n\n.mat-form-field {\n  width: 100%;\n}\n\nform small.error {\n  position: relative;\n  top: -24px;\n}\n\n.param-name {\n  min-width: 40%;\n}\n\n.light-data-text {\n  font-size: 16px;\n}\n\nth {\n  padding: 6px 4px;\n  border-top: none;\n}\n\ntd {\n  padding: 6px 4px;\n  border-top: none;\n}\n\ntr {\n  border-bottom: 1px solid #e0e0e0;\n}\n.mat-form-field .mat-form-field-wrapper {\n  padding: 0px !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
